<template>
    <div class="cost-detail">
        <div class="cost-detail-nav">
            <el-button size="mini" @click="$router.back(-1)">返回</el-button>
            <span v-has="'06020009'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="refundStamp"
                    v-if="headInfo.orderType==='3' && (headInfo.costStatus==='1' || headInfo.costStatus==='7')">退款申请函盖章</el-button>
            </span>
            <span v-has="'06020010'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="refundStamp"
                    v-if="headInfo.orderType==='3' && (headInfo.costStatus==='2' || headInfo.costStatus==='3' ||
                    headInfo.costStatus==='4' || headInfo.costStatus==='5' || headInfo.costStatus==='6')">退款申请函预览</el-button>
            </span>
            <span v-has="'06020011'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="receiptsPreview('bidPayshow1')"
                    v-if="moduleFileInfo.length > 0">收据预览</el-button>
            </span>
            <span v-has="'06020012'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="receiptsPreview('2')"
                    v-if="moduleFileInfo.length > 0">收据下载</el-button>
            </span>
        </div>
        <div class="cost-detail-cont">
            <div class="content">
                <div class="content-box">
                    <div><span class="content-title">{{headInfo.bidName}}</span> <span class="content-label">{{headInfo.costStatusText}}</span></div>
                    <div class="content-desc" v-if="headInfo.orderType!=='3'">
                        <span class="content-desc-item">订单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                        <span class="content-desc-item">订单类型<span class="content-desc-cont">{{headInfo.orderTypeText}}</span></span>
                        <span class="content-desc-item">应缴金额<span class="content-desc-cont">{{headInfo.receivePayAmount || 0}}</span></span>
                        <span class="content-desc-item">实缴金额<span class="content-desc-cont">{{headInfo.actualReceivePay || 0}}</span></span>
                        <span class="content-desc-item">缴纳方式<span class="content-desc-cont">{{headInfo.payTypeText}}</span></span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                        <span class="content-desc-item">付款时间<span class="content-desc-cont">{{headInfo.transactionTime}}</span></span>
                    </div>
                    <div class="content-desc" v-if="headInfo.orderType==='3'">
                        <span class="content-desc-item">退款单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                        <span class="content-desc-item">原保证金缴纳金额<span class="content-desc-cont">{{headInfo.orginDepositAmount || 0}}</span></span>
                        <span class="content-desc-item">罚扣款金额<span class="content-desc-cont">{{headInfo.penaltyAmount || 0}}</span></span>
                        <span class="content-desc-item">转合同押金金额<span class="content-desc-cont">{{headInfo.depositContract || 0}}</span></span>
                        <span class="content-desc-item">应退保证金金额<span class="content-desc-cont">{{headInfo.receiveRefundDeposit || 0}}</span></span>
                        <span class="content-desc-item">实退保证金金额<span class="content-desc-cont">{{headInfo.actualRefundDeposit || refundAmount || 0}}</span></span>
                        <span class="content-desc-item">开户银行<span class="content-desc-cont">{{headInfo.bankCode}}</span></span>
                        <span class="content-desc-item" v-if="headInfo.costStatus==='1'">
                            银行账号
                            <span class="content-desc-cont">{{headInfo.bankAccount}}</span>
                            <i class="el-icon-edit-outline content-desc-editor"  @click="selectContant()"></i>
                        </span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                        <span class="content-desc-item">退款时间<span class="content-desc-cont">{{headInfo.transactionTime}}</span></span>
                        <span class="content-desc-item" v-if="headInfo.costStatus==='4'">驳回原因<span class="content-desc-cont">{{headInfo.costRejectionCause}}</span></span>
                        <span class="content-desc-item" v-if="headInfo.costStatus==='4'">联系人<span class="content-desc-cont">{{headInfo.contactName}}</span></span>
                        <span class="content-desc-item" v-if="headInfo.costStatus==='4'">联系方式<span class="content-desc-cont">{{headInfo.contactNumber}}</span></span>
                    </div>
                </div>
            </div>
            <div class="tab1" v-if="headInfo.payType === '1'">
                <div class="tab1-title">凭证（银行转账信息凭证）</div>
                <el-table :data="headInfo.bidModuleFiles" class="tab1-title-table" border tooltip-effect='dark'>
                    <el-table-column prop="fileName" label="文件名称" align="center"></el-table-column>
                    <el-table-column prop="updateTime" label="上传时间" align="center"></el-table-column>
                    <el-table-column prop="action" label="操作" align="center">
                        <template slot-scope="scope">
                            <span v-has="'06020013'"><el-button type="text" size="small" @click="actionFn(scope.row, '1')">下载</el-button></span>
                            <span v-has="'06020014'"><el-button  class="margin-left" type="text" size="small" @click="actionFn(scope.row, '0')">预览</el-button></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="file-upload-wrap" v-if="headInfo.payType === '3'">
                <div class="file-upload-wrap__header">
                    <div>附件文档</div>
                    <div style="display: flex;">
                        <el-button type="primary" size="small" @click="downTemp">下载模板</el-button>
                    </div>
                </div>
                <el-table :data="attachmentList" style="width: 100%;margin-top: 10px;" border >
                    <el-table-column show-overflow-tooltip prop="fileName" label="附件名称" align="center"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="updateTime" label="上传时间" align="center"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="actionFn(scope.row, '0')">预览</el-button>
                            <el-button type="text" size="small" @click="actionFn(scope.row, '1')">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="tab1" v-if="headInfo.payType === '3'">
                <div class="tab1-title">运费明细</div>
                <el-table :data="costDetails" style="width: 100%" border tooltip-effect='dark' >
                    <el-table-column prop="relationOrderNo" label="未结单号" align="center"></el-table-column>
                    <el-table-column prop="totalAmount" label="总金额" align="center"></el-table-column>
                    <el-table-column prop="availableAmount" label="可用金额" align="center"></el-table-column>
                    <el-table-column prop="transferAmount" label="转投标保证金金额" align="center"></el-table-column>
                </el-table>
            </div>
        </div>
        <otpAdvanceDialog ref="contactadvanceDialog" @confirm="detaliSearchSure"> </otpAdvanceDialog>
        <bid-price-list :payTitle="'退款申请函盖章'" :originFlag="'2'" :MDialogshow="bidPayshow" :rowBidDialogData="bidPayshowRowData" @mdialogFn="mdialogFn"></bid-price-list>
    </div>
</template>
<script>
import { filePreview } from '@/utils/filePreview.js';
import { getSupplierCostByBond, getSupplierCostDetails } from '../../../../lsrm/api/myBidding.js';
import otpAdvanceDialog from '@/components/lots/otpAdvanceDialog';
import { moduleFile } from '../../../../lsrm/api/annoMana.js';
import { dictWithUrl } from '@/components/lots/api';
import BidPriceList from '../bidManagement/BidPriceList.vue';
export default {
    data() {
        return {
            bidPayshow: false,
            MDialogshow: false,
            rowBidDialogData: {},
            bidPayshowRowData: {},
            timer: null,
            maxtime: '',
            timeover: '',
            headInfo: {},
            params: {
                name: '',
                value: 'bankAccount',
                advanceLabel: '选择银行账户',
                advanceConfig: [
                    { prop: 'bankAccount', value: '银行账户' },
                    { prop: 'bankAccountName', value: '账户名称' },
                    { prop: 'ubankNo', value: '银联号' },
                    { prop: 'bankName', value: '银行名称' }
                ],
                tableConfig: [
                    { prop: 'bankAccount', value: '银行账户' },
                    { prop: 'bankAccountName', value: '账户名称' },
                    { prop: 'ubankNo', value: '银联号' },
                    { prop: 'bankName', value: '银行名称' }
                ],
                advanceUrl: `/supplier/bankAccounts/${this.$route.query.supplierCode}/`,
                prefix: '/api-srm-web',
                cbParams: ['bankAccount', 'bankName', 'bankAccountName', 'bankCode']
            },
            refundAmount: 0,
            dictData: [],
            costDetails: [],
            moduleFileInfo: [],
            attachmentList: [],
        };
    },
    components: { otpAdvanceDialog, BidPriceList },
    mounted() {
        dictWithUrl('BID_EXPENSE_ORDER_TYPE,BID_PAY_TYPE,BID_COST_STATUS').then(res => {
            this.dictData = res.data;
            getSupplierCostByBond({ id: this.$route.query.id, orderType: this.$route.query.orderType }).then(res => {
                if (res && +res.code === 0) {
                    this.headInfo = res.data;
                    this.refundAmount = this.sub(this.headInfo.actualReceivePay, this.headInfo.penaltyAmount);
                    this.refundAmount = +this.headInfo.refundAmount ? this.sub(this.headInfo.refundAmount, this.headInfo.depositContract) : 0;
                    this.headInfo.orderTypeText = this.dictData.BID_EXPENSE_ORDER_TYPE[this.headInfo.orderType];
                    this.headInfo.payTypeText = this.dictData.BID_PAY_TYPE[this.headInfo.payType];
                    this.headInfo.costStatusText = this.dictData.BID_COST_STATUS[this.headInfo.costStatus];
                    getSupplierCostDetails({ orderNo: this.headInfo.orderNo }).then(res => {
                        this.costDetails = res.data.list;
                    });
                    moduleFile({ stampStatus: 'Y', moduleNo: this.headInfo.orderNo, fileAttribute: '19' }).then((res) => {
                        if (res && +res.code === 0) { this.moduleFileInfo = (res.data && res.data.list) || []; }
                    });
                    this.attachmentList = res.data.bidModuleFiles || []
                }
            });
        });
    },
    methods: {
        downTemp(){
            dictWithUrl('SRM_TEMPLATE_COLLECTION').then(res => {
                if(res.data.SRM_TEMPLATE_COLLECTION.FREIGHT_TO_DEPOSIT){
                    window.open(res.data.SRM_TEMPLATE_COLLECTION.FREIGHT_TO_DEPOSIT, '_parent');
                }else{
                    this.$message.warning('下载失败，模板链接不存在')
                }
            });
        },
        receiptsPreview(type) {
            if (type === '2') {
                window.open(this.moduleFileInfo[0].fileUrl, '_parent');
            } else {
                filePreview(this.moduleFileInfo[0]);
            }
        },
        refundStamp() {
            this.bidPayshow = true;
            this.bidPayshowRowData = this.headInfo;
        },
        mdialogFn() {
            this.bidPayshow = false;
            this.MDialogshow = false;
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else {
                filePreview(row);
            }
        },
        selectContant(row) {
            const current = this.params;
            const advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.formData[sourceProp];
                });
            }
            this.$refs.contactadvanceDialog.show(true, current, advanceCascade);
        },
        detaliSearchSure(res) {
            this.headInfo.bankAccountName = res.bankAccountName;
            this.headInfo.bankAccount = res.bankAccount;
            this.headInfo.bankCode = res.bankName;
        },
        sealFn() {
            this.MDialogshow = true;
            this.rowBidDialogData = this.headInfo;
        },
        downLoad(row) {
            window.open(row.fileUrl, '_parent');
        },
        sub(arg1, arg2) {
            // 减法精度处理
            let r1 = ''; let r2 = ''; let m = ''; let n = '';
            try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
            try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
            m = Math.pow(10, Math.max(r1, r2));
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m) / m).toFixed(n);
        }
    }
};
</script>

<style lang="less">
.cost-detail {
    margin: 0 10px;
    font-size: 12px;
    background: #fff;
    .margin-left {
        margin-left: 10px;
    }
    .content-box {
        width:100%;
    }
    .tab1-title-table {
        width:100%;
    }
    .cost-detail-cont {
        overflow-y: auto;
        min-height: calc(~"100vh - 110px") !important;
        max-height: calc(~"100vh - 110px") !important;
    }
    .cost-detail-nav {
        padding-left: 10px;
        width: 100%;
        height: 46px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
    .content {
        margin: 10px;
        padding: 14px;
        min-width: 1400px;
        box-sizing: border-box;
        background: #F8F8F8;
        vertical-align: middle;
        display: flex;
        align-items: center;
        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }
        .content-label {
            margin-left: 12px;
            padding: 3px 6px;
            border-radius: 2px;
            background: #FF7C24;
            display: inline-block;
            color: #fff;
        }
        .content-desc {
            margin-top: 15px;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        }
        .content-desc-item {
            margin: 0 25px 4px 0;
            color: #888888;
        }
        .content-desc-editor {
            margin-left: 10px;
            font-size: 14px;
            color: #FF7C24;
            cursor: pointer;
            color: #33c9cc;
        }
        .content-desc-cont {
            margin-left: 5px;
            color: #333333;
        }
    }
    .tab1 {
        padding: 10px;
        .tab1-title {
            margin-bottom: 10px;
        }
    }
    .file-upload-wrap{
        padding: 10px;
        &__header{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
}

</style>